export enum RoutePath {
  Card = '/card',
  CardStatus = '/card-status/:userId',
  Checkout = '/checkout',
  Contact = '/contact',
  Contributions = '/profile/contributions',
  CurrentFunctions = '/profile/current-functions',
  Distictions = '/profile/distinctions',
  Permissions = '/profile/permissions',
  History = '/profile/history',
  Agreements = '/profile/agreements',
  Home = '/',
  Login = '/login',
  Membership = '/profile/membership',
  PaymentFailed = '/payment/failed',
  PaymentResult = '/payment/payment_result',
  PaymentSuccessful = '/payment/successful',
  PersonalData = '/profile/settings',
  Profile = '/profile',
  Register = '/register',
  RegisterSuccess = '/register-success',
  Document = '/document/:documentId',
}
